var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect, useRef, useState, } from 'react';
import Cookies from 'js-cookie';
import { Sidebar } from '@michelin/acid-components';
import { AppsMenu } from '../AppsMenu/AppsMenu';
import { CentralProviderContext, LegalDocsContext } from '../../centralProviderContext/CentralProviderContext';
import { useLegalDocuments } from '../../hooks/useLegalDocuments';
// eslint-disable-next-line no-redeclare
function CentralProviderSidebar(props) {
    var initial = !!Cookies.get('sidebar-minimized');
    var _a = __read(useState(!initial), 2), sidebarOpen = _a[0], setSidebarOpen = _a[1];
    var _b = __read(useState(''), 2), execute = _b[0], setExecute = _b[1];
    var ref = useRef(null);
    var setSidebarRef = useContext(CentralProviderContext).setSidebarRef;
    var getSalesForceTermsLink = useLegalDocuments().getSalesForceTermsLink;
    var legalContext = React.useContext(LegalDocsContext);
    var onShrink = props.onShrink, onGrow = props.onGrow, _c = props.showApplicationSelector, showApplicationSelector = _c === void 0 ? true : _c;
    var handlerSidebarMovement = function (e) {
        if (e === undefined)
            return;
        setSidebarOpen(e);
    };
    var onSidebarShrink = function (e) {
        handlerSidebarMovement(e);
        if (onShrink)
            onShrink(e);
    };
    var onSidebarGrow = function (e) {
        handlerSidebarMovement(e);
        if (onGrow)
            onGrow(e);
    };
    useEffect(function () {
        if (ref && ref.current) {
            setSidebarRef(ref);
        }
        legalContext.showLegalDocs(props.showLegalInformation || false);
    }, [ref]);
    // unmount
    useEffect(function () { return function () { return setSidebarRef(null); }; }, []);
    var openSidebar = function () {
        var d = new Date();
        setExecute(d.toString());
    };
    return (React.createElement(Sidebar, __assign({}, props, { onShrink: onSidebarShrink, onGrow: onSidebarGrow, execute: execute, onLegalLinkClick: function (doc) { return window.open(getSalesForceTermsLink(doc), '_blank'); } }), showApplicationSelector
        && (React.createElement("div", { id: "central-provider-sidebar", ref: ref, style: {
                display: 'flex',
                justifyContent: 'center',
                margin: '14px 0',
                width: '100%',
            } },
            React.createElement(AppsMenu, { small: !sidebarOpen, onClickWhenSmall: openSidebar })))));
}
CentralProviderSidebar.defaultProps = {
    variant: 'permanent',
    open: true,
    title: '',
    drawerWidth: 240,
    items: [],
    versions: [],
    rememberMinifiedStatus: true,
    position: 'top',
    showLegalInformation: false,
    showCopyright: false,
};
export default CentralProviderSidebar;
//# sourceMappingURL=CentralProviderSidebar.js.map